import React, { useEffect } from "react";
import '@fortawesome/fontawesome-free/css/all.min.css'

export const Temp_Campaign: React.FC = () => {

    useEffect(() => {
        const handleChatClick = () => {
            window.SI_API?.showPopup();
        };

        const chatButtons = document.querySelectorAll('.btn-chat');
        chatButtons.forEach(btn => btn.addEventListener('click', handleChatClick));

        return () => {
            chatButtons.forEach(btn => btn.removeEventListener('click', handleChatClick));
        };
    }, []);

    //Campagin
    return <>
        <div className="container">

            <div>
                <div className="text-center text-sm-start">
                    <div className="d-sm-flex align-items-center">
                        <img className="mb-3 mb-sm-0 me-sm-5 flex-shrink-0" alt="Supplies - Who?"
                            src="https://zebratechnologies.blob.core.windows.net/public/campaigns/supplies/Supplies%20-%20Who.svg" />
                        <div>
                            <h2 className="mb-2">Who?</h2>
                            This campaign is for Zebra customers who are using older printer models and would benefit from upgrading to newer technology to enhance their business operations.
                        </div>
                    </div>
                    <hr />
                    <div className="d-sm-flex align-items-center"><img className="mb-3 mb-sm-0 me-sm-5 flex-shrink-0" alt="Supplies - What?"
                        src="https://zebratechnologies.blob.core.windows.net/public/campaigns/supplies/Supplies%20-%20What.svg" />
                        <div>
                            <h2 className="mb-2">What?</h2>
                            A trade-up program that enables customers to upgrade their current printers to the latest Zebra models.
                            By upgrading, customers can unlock new capabilities, including improved speed, proactive security
                            defense, and options for RFID and eco-friendly linerless media. Upgrading customers can also access promotional savings on their first three boxes of supplies through the “Would You Like Supplies With That?” offer.

                        </div>
                    </div>
                    <hr />
                    <div className="d-sm-flex align-items-center"><img className="mb-3 mb-sm-0 me-sm-5 flex-shrink-0" alt="Supplies - When?"
                        src="https://zebratechnologies.blob.core.windows.net/public/campaigns/supplies/Supplies%20-%20When.svg" />
                        <div>
                            <h2 className="mb-2">When?</h2>
                            This is a Q3 campaign running until the 30th September, 2026.
                        </div>
                    </div>
                    <hr />
                    <div className="d-sm-flex align-items-center"><img className="mb-3 mb-sm-0 me-sm-5 flex-shrink-0"
                        alt="Supplies - Where?"
                        src="https://zebratechnologies.blob.core.windows.net/public/campaigns/supplies/Supplies%20-%20Where.svg" />
                        <div>
                            <h2 className="mb-2">Where?</h2>Full details, terms, and conditions can be found on the “Would You Like
                            There are multiple promotions that can be linked together to deliver the proposition to your customers, including Zebra Trade UP, the Discontinued Printhead Trade Up Promotion - applicable to the EU and EFTA regions only, and “Would You Like Supplies With That?” - eligible to all EMEA regions. Terms and conditions apply. The campaign is designed to be digitally executed with a mock-up landing page, email copy, LinkedIn Tiles, and Web banners. We have also included a flyer if you would like to expand your promotional activities.
                        </div>
                    </div>
                    <hr />
                    <div className="d-sm-flex align-items-center"><img className="mb-3 mb-sm-0 me-sm-5 flex-shrink-0" alt="Supplies - Why?"
                        src="https://zebratechnologies.blob.core.windows.net/public/campaigns/supplies/Supplies%20-%20Why.svg" />
                        <div>
                            <h2 className="mb-2">Why?</h2>
                            The goal is to encourage customers to trade-up to the latest Zebra printer technology from older Zebra printers with printheads that have recently gone end-of-life, enabling them to protect their workflows, boost efficiency, and adopt sustainable, future-ready features that support their evolving business needs.
                        </div>
                    </div>
                    <hr />
                    <div className="d-sm-flex align-items-center"><img className="mb-3 mb-sm-0 me-sm-5 flex-shrink-0" alt="Supplies - How?"
                        src="https://zebratechnologies.blob.core.windows.net/public/campaigns/supplies/Supplies%20-%20How.svg" />
                        <div>
                            <h2 className="mb-2">How?</h2>
                            Sales Partners should contact their customers to discuss the challenges they may face with outdated printer technology and the benefits of upgrading to the latest Zebra printers.
                        </div>
                    </div>
                </div>
                <hr className="hr-thick" />
                <p>
                    <strong>
                        The assets we are providing for this campaign are listed below with a suggested marketing plan for you to follow. This campaign is available in English, French, German, Italian, Spanish, Polish and Turkish.
                    </strong>
                </p>
                <div className="scroll-horizontal">
                    <table>
                        <thead>
                            <tr>
                                <th>Printer Upgrade Campaign</th>
                                <th colSpan={6}>Offer duration (Ends 30<sup>th</sup> September)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Publish Web Banners</td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                            </tr>
                            <tr>
                                <td>Publish LinkedIn Posts</td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                            </tr>
                            <tr>
                                <td>Publish Landing Page</td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                            </tr>
                            <tr>
                                <td>Promote Flyer</td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                            </tr>
                            <tr>
                                <td>Send Campaign Emails</td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                                <td><i className="fa-solid fa-check"></i></td>
                            </tr>
                        </tbody>
                    </table>
                </div>



                <div className="card card-dark py-3 px-5 cursor-pointer mb-5 btn-chat mt-5">
                    <div className="d-md-flex align-items-center gap-3">
                        <img width="80px" alt="Zebra Concierge"
                            src="https://zebratechnologies.blob.core.windows.net/public/Zebra_Concierge.png" />
                        <div>
                            <h3 className="my-2">
                                On request, we can co-brand this campaign for you.
                            </h3>
                            Please message us using the concierge chat function on the right-hand side to speak with an agent who can assist you.
                        </div>
                    </div>
                </div>



                <div className="examples">
                    <div className="d-flex flex-wrap gap-5">

                        <div>
                            <h2>Flyer</h2>
                            <img alt="Flyer"
                                src="https://zebratechnologies.blob.core.windows.net/public/campaigns/26_printer/EN/Flyer_EN.png" />
                        </div>

                        <div>
                            <h2>Web Banners & LinkedIn Tiles</h2>
                            <img alt="Web Banners & LinkedIn Tiles"
                                src="https://zebratechnologies.blob.core.windows.net/public/campaigns/26_printer/EN/Web%20Banners_EN.png" />
                        </div>

                        <div>
                            <h2>Landing Page</h2>
                            <img alt="Landing Page"
                                src="https://zebratechnologies.blob.core.windows.net/public/campaigns/26_printer/EN/Landing%20Page_EN.png" />
                        </div>

                    </div>
                </div>


            </div>

        </div>
    </>



};

export default Temp_Campaign;